import { autocompleteClasses } from "@mui/material/Autocomplete"
import Typography from "@mui/material/Typography"

import Row from "../../../common/components/Row"
import CandidateAvatar from "./CandidateAvatar"

export default function CandidateDropdownOption({ option, props }) {
  return (
    <Row
      component="li"
      sx={{
        alignItems: "center",
        [`&.${autocompleteClasses.option}`]: { p: 1 },
      }}
      {...props}
    >
      <CandidateAvatar candidate={option} size="32px" fontSize="0.75em" />
      <Typography variant="body1" sx={{ ml: 2 }}>
        {option.candidate_name}
      </Typography>
    </Row>
  )
}
